import apiClient, { clearSharedGetCache } from "./client";

export const fetchUsers = async (params = {}) => {
  const response = await apiClient.get("/users", { params });
  return response.data;
};

export const inviteUser = async (payload) => {
  const response = await apiClient.post("/users/invite", payload);
  clearSharedGetCache();
  return response.data;
};

export const updateManagedUser = async (userId, payload) => {
  const response = await apiClient.put(`/users/${userId}`, payload);
  clearSharedGetCache();
  return response.data;
};

export const sendUserPasswordReset = async (userId, payload) => {
  const response = await apiClient.post(`/users/${userId}/password-reset`, payload);
  return response.data;
};

export const generateManagedUserResetLink = async (userId, payload) => {
  const response = await apiClient.post(`/users/${userId}/password-reset-link`, payload);
  return response.data;
};